<template>

    <div class="form-control">
            <input v-model="myValue.cep" @input="searchCep" class='' type="text" ref="cep" v-mask="'#####-###'"  placeholder="CEP">
            <input v-show="cepcomplete" @change="updateValue" v-model="myValue.rua" class='' type="text" ref="rua" placeholder="Rua">
            <input v-show="cepcomplete" @change="updateValue" v-model="myValue.bairro" class='' type="text" ref="bairro" placeholder="Bairro">
            <input v-show="cepcomplete" @change="updateValue" v-model="myValue.cidade" class='' type="text" ref="cidade" placeholder="Cidade">
            <input v-show="cepcomplete" @change="updateValue" v-model="myValue.estado" class='' type="text" ref="estado" placeholder="Estado">
            <input v-show="cepcomplete" @change="updateValue" v-model="myValue.numero" class='' type="text" ref="numero" placeholder="Nº">
    </div>

</template>

<script>
import _ from 'lodash';
import api from '@/api';

export default {
    props:['value'],
    data(){
        return { cepcomplete:false, myValue:{cep:'',rua:'',numero:'',bairro:'',cidade:'',estado:''} }
    },
    created:function(){
        if( _.isObject(this.value)){
            this.myValue = {...this.myValue,...this.value}
            this.getCep(); //set cepcomplete if it is ok
        }
    },
    watch:{
        value:function(val){
            if( ! _.isEqual(val, this.myValue)  ){
                this.myValue = {...this.myValue,...this.value}
                if(this.myValue.cep != this.value.cep)
                        this.getCep(); //set cepcomplete if it is ok
             }
        },
        myValue:function(val, oldval){
            
            if( ! _.isEqual(val, oldval)  ){
                this.$emit('change',val)
                this.$emit('input',val)
             }
        }
    },
    
    methods:{
         updateValue:function(){
            // let val = this.$refs.input.value;
            // this.myValue = val
            this.$emit('change',this.myValue)
            this.$emit('input',this.myValue)
        },
         inputValue:function(e){
            // let val = this.$refs.input.value;
            // this.myValue = val
            this.$emit('input',this.myValue)
        },
        getCep:function(){
                var cep = this.myValue.cep.replace(/\D/g, '');
                if (cep != "") {
                    var validacep = /^[0-9]{8}$/;
                    if(validacep.test(cep)) {
                        this.cepcomplete = true;
                        return cep;
                    }
                }
                return '';
        },
         searchCep:async function(el){
               
            if(this.getCep() == '') return;

            var url = `https://viacep.com.br/ws/${this.getCep()}/json`;             
            var res = await api.getJSONAsync(url,{},true);
            console.log(res);
            if(res.cep){
                this.myValue.cep = res.cep;
                this.myValue.rua = res.logradouro;
                this.myValue.bairro = res.bairro;
                this.myValue.cidade = res.localidade;
                this.myValue.estado = res.uf;
                this.$refs.numero.focus();

                this.$emit('change', this.myValue)
                this.$emit('input', this.myValue)
            }

        },

    }
}
</script>

<style scoped lang="stylus">
    .form-control{
        height:auto;
    }

    .form-control input{
        border:none;
        padding:5px 3px;
        font-size:14px;
        outline none;
        display:block;
        width 100%;
        &:focus{
            background rgba(black,0.1);
        }
        &:-internal-autofill-previewed,&:-internal-autofill-selected{
           -webkit-box-shadow: 0 0 0 30px white inset !important; //to remove autocomplete yellow
        }

    }
</style>
